import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "@cart-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export enum RX_OPTED {
    IN = "opt_in",
    OUT = "opt_out",
}

export const clickSpecialInstructions = (
    restaurantId: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
    isClosed?: boolean,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_SPECIAL_INSTRUCTIONS,
        label: restaurantId,
        extraParams: JSON.stringify({ isClosed }),
    });
};

export const clickSaveInstructions = (
    restaurantId: string,
    rxInstructions: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_SAVE_SPECIAL_INSTRUCTIONS,
        label: restaurantId,
        context: JSON.stringify({ rxInstructions }),
    });
};

export const impressionSpecialInstructions = (
    restaurantId: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSSION_SPECIAL_INSTRUCTIONS,
        label: restaurantId,
    });
};

// When Rx Instruction Half Card loads
export const impressionSpecialInstructionRequest = (
    restaurantId: string,
    isOptedIn: boolean,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSSION_SPECIAL_INSTRUCTION_REQUEST,
        label: restaurantId,
        context: isOptedIn ? RX_OPTED.IN : RX_OPTED.OUT,
    });
};

// When Rx Instruction request submitted from hald card
export const clickSpecialInstructionRequest = (
    restaurantId: string,
    isOptedIn: boolean,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_SPECIAL_INSTRUCTION_REQUEST,
        label: restaurantId,
        context: isOptedIn ? RX_OPTED.IN : RX_OPTED.OUT,
    });
};

// When existing Rx Instruction request updated from half card
export const clickUpdateSpecialInstructionRequest = (
    restaurantId: string,
    clickedCta: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_SPECIAL_INSTRUCTION_REQUEST_EDIT,
        label: restaurantId,
        context: clickedCta,
    });
};
